<ng-container *ngIf="sharedDataState$ | async as state">
    <div class="costinglevel-article-mapping-container mat-elevation-z8">
        <div class="table-header">
            <mat-form-field  style="width: 30%" subscriptSizing="dynamic">
                <mat-label>{{ "app.model.costingLevel-articleNr-mapping.label" | translate }}</mat-label>
                <mat-select [formControl]="costingLevelSelectionFormControl">
                    @for (costingLevel of state.costingLevelLookup | keyvalue; track costingLevel) {
                        <mat-option *ngIf="!costingLevel.value.other" [value]="costingLevel.value.id">
                            {{ costingLevel.value.name }}
                        </mat-option>
                    }

                </mat-select>
                <button mat-icon-button matSuffix (click)="costingLevelSelectionFormControl.setValue(null); $event.stopPropagation()">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>

            <mat-form-field subscriptSizing="dynamic">
                <input matInput #filter (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                <button mat-icon-button matSuffix aria-label="clear" *ngIf="filter.value"
                        (click)="filter.value=''; applyFilter('');">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <mat-progress-bar color="accent" [style.visibility]="state.isLoading ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>
        <div class="table-container">
            <table mat-table matSort [dataSource]="dataSource">

                <ng-container matColumnDef="costingLevelName">
                    <th mat-header-cell *matHeaderCellDef
                        mat-sort-header>{{ "app.model.costingLevel-article-mapping.costingLevel.label" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.costingLevel.name }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="articleNr">
                    <th mat-header-cell *matHeaderCellDef
                        mat-sort-header>{{ "app.model.costingLevel-article-mapping.articleNr.label" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.articleNr }}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="layout.columns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: layout.columns;"></tr>

            </table>
            <mat-paginator [pageSize]="20" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </div>
</ng-container>
